export default (arr: any[], index1: number, index2: number) => {
  const array = [...arr];
  [
    array[index1], array[index2],
  ] = [
    array[index2], array[index1]
  ];
  return array;
};
